<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#ff00a3" type="ball-atom" [fullScreen]="true">
    <!-- <p style="color: rgb(255, 10, 145)">Domii</p> -->
</ngx-spinner>